/**
 * A utility function to format a date object to ISO 8601 string format with timezone offset
 * This is different from the built-in toISOString() method which returns the date in UTC timezone
 * Source: https://stackoverflow.com/questions/17415579/how-to-iso-8601-format-a-date-with-timezone-offset-in-javascript
 * 
 * @param {Date} date date object to format
 * @returns string in ISO format (YYYY-MM-DDTHH:MM:SSZ)
 */
export function toISOString(date: Date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num: number) {
      return (num < 10 ? '0' : '') + num;
    };

  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    dif + pad(Math.floor(Math.abs(tzo) / 60)) +
    ':' + pad(Math.abs(tzo) % 60);
}

/**
 * Utility function to update the search parameters of a URL
 * @param {string} url The url to update
 * @param {[key: string]: string} searchParameters An object of key-value pairs to update the search parameters
 * @returns {string} The updated URL
 */
export function updateSearchParams(url: string, searchParameters: { [key: string]: string }) {
  let urlToUse = url

  // // If the URL contains encoded components, we need to decode it first
  // if (decodeURI(url) !== decodeURIComponent(url)) {
  //   urlToUse = decodeURI(url);
  // }

  const urlObject = new URL(urlToUse, window.location.href);
  const searchParams = urlObject.searchParams;
  Object.keys(searchParameters).forEach((key: string) => {
    searchParams.set(key, searchParameters[key]);
  });

  return urlObject.toString();
}

export function escapeParam(param: any) {
  return String(param)
    .replaceAll("\\", "\\\\")
    .replaceAll(",", "\\,");
}

export function reduceArrayAndEscape(param: any) {
  if (Array.isArray(param)) {
    let escapedParams = param.map(function (elem) {
      return escapeParam(elem);
    });
    return escapedParams.join(",");
  }
  return escapeParam(param);
}

export function convertDateToIsoString(date: any) {
  let paramAsDate = new Date(date);
  if (isNaN(paramAsDate.getTime())) {
    throw "Cannot interpret parameter as Date";
  }
  return paramAsDate.toISOString();
}